var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlocks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1556 7.22222C15.1512 7.22222 15.649 7.22222 16.0293 7.02846C16.3638 6.85802 16.6358 6.58605 16.8062 6.25154C17 5.87125 17 5.37343 17 4.37778V3.84444C17 2.8488 17 2.35097 16.8062 1.97068C16.6358 1.63617 16.3638 1.36421 16.0293 1.19377C15.649 1 15.1512 1 14.1556 1L3.84444 1C2.8488 1 2.35097 1 1.97068 1.19377C1.63617 1.36421 1.36421 1.63617 1.19377 1.97068C1 2.35097 1 2.8488 1 3.84444L1 4.37778C1 5.37343 1 5.87125 1.19377 6.25154C1.36421 6.58605 1.63617 6.85801 1.97068 7.02846C2.35097 7.22222 2.8488 7.22222 3.84444 7.22222L14.1556 7.22222Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1556 17C15.1512 17 15.649 17 16.0293 16.8062C16.3638 16.6358 16.6358 16.3638 16.8062 16.0293C17 15.649 17 15.1512 17 14.1556V13.6222C17 12.6266 17 12.1287 16.8062 11.7485C16.6358 11.414 16.3638 11.142 16.0293 10.9715C15.649 10.7778 15.1512 10.7778 14.1556 10.7778L3.84444 10.7778C2.8488 10.7778 2.35097 10.7778 1.97068 10.9715C1.63617 11.142 1.36421 11.414 1.19377 11.7485C1 12.1287 1 12.6266 1 13.6222L1 14.1556C1 15.1512 1 15.649 1.19377 16.0293C1.36421 16.3638 1.63617 16.6358 1.97068 16.8062C2.35097 17 2.8488 17 3.84444 17H14.1556Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocks);
export default __webpack_public_path__ + "static/media/Blocks.2f3b927e3983f3dbaa081910c3205481.svg";
export { ForwardRef as ReactComponent };